export default __webpack_public_path__ + "static/media/Ferdinand-Putra.ca3aa3f6.png";